import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CastMode } from '../../core/routing/cast-mode';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
    selector: 'app-main-layout',
    imports: [
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        HeaderComponent,
        SidenavComponent,
        RouterOutlet,
    ],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss',
    host: { '(document:keydown.escape)': 'castMode.casting() && castMode.stop()' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent {
  // No header or sidenav while casting (?cast=1 on a castable page) or on an always-bare route (data.bareLayout).
  protected readonly castMode = inject(CastMode);
}
